<template>
  <div class="row">
    <!--  评论列表  -->
    <div class="flex xs12">
      <va-card title="评论">
        <div class="row align--center mb-1">
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              :value="toUid"
              placeholder="对导师uid筛选"
              @input="searchByToUid"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex xs12 sm6">
            <va-input
              class="ma-0"
              :value="fromUid"
              placeholder="对学员uid筛选"
              @input="searchByFromUid"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex xs12 sm12">
            <va-input
              class="ma-0"
              :value="content"
              placeholder="search by 评论内容"
              @input="searchByContent"
              removable
            >
              <va-icon name="fa fa-search" slot="prepend"/>
            </va-input>
          </div>
          <div class="flex md6 xs12 sm6">
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
          <div class="flex md6 xs12 sm6">

            <div class="d-flex justify--end">

              <va-button color="info" outline small :to='{name:`saveComment`}'>新增评论</va-button>
            </div>
          </div>
        </div>

        <va-data-table
          :fields="fields"
          :data="comments"
          :loading="loading"
          :totalPages="totalPages"
          class="force-wrap"
          @page-selected="listComment"
          api-mode
        >
          <!-- 导师名字 -->
          <template slot="user" slot-scope="props" v-if="props.rowData.fromUserBasicInfo">
            <va-button color="gray" flat small :to='{path:`/admin/users/updateUser/${props.rowData.fromUserBasicInfo.uid}`}'>
              {{ props.rowData.fromUserBasicInfo.nickname }}

            </va-button>
          </template>
          <template slot="mentor" slot-scope="props" v-if="props.rowData.toUserBasicInfo">
            <va-button color="gray" flat small :to='{path:`/admin/mentors/getMentor/${props.rowData.toUserBasicInfo.uid}`}'>
              {{ props.rowData.toUserBasicInfo.nickname }}
            </va-button>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="删除" placement="top">
              <va-button flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true;deleteCommentId=props.rowData.commentId"/>
            </va-popover>
          </template>
        </va-data-table>

        <va-modal
          v-model="deleteModal"
          title="删除评论"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>

import debounce from 'lodash/debounce'
import commentApi from '@/api/comment'
import { formatTime } from '@/utils/common'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      comments: [],
      content: '',
      fromUid: this.$route.query.fromUid,
      toUid: this.$route.query.toUid,
      loading: true,
      pageNumber: 1,
      totalCount: 0,
      pageSize: 10,
      totalPages: 1,
      deleteModal: false,
      deleteCommentId: null,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:user',
          title: '学员',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'comment',
          title: '评论内容',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:mentor',
          title: '被评论导师',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '评论时间',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.fromUid = this.$route.query.fromUid
    this.toUid = this.$route.query.toUid
    this.listComment()
    console.log(this.fromUid)
    console.log(this.toUid)
  },
  methods: {
    listComment (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageSize: this.pageSize,
        pageNumber: pageNumber,
        fromUid: this.fromUid,
        toUid: this.toUid,
        comment: this.content,
      }
      if (this.$route.params.toUid != null) {
        params.toUid = this.$route.params.toUid
      }
      if (this.$route.params.fromUid != null) {
        params.fromUid = this.$route.params.fromUid
      }
      commentApi.listComment(params).then(response => {
        this.comments = response.comments
        this.comments.forEach(x => {
          x.createTime = formatTime(x.createTime)
        })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => alert(error))
    },
    handleStatusChange (status) {
      this.status = status
      this.listComment()
    },
    confirmDelete () {
      if (this.deleteCommentId === null) return
      commentApi.deleteComment(this.deleteCommentId).then(response => {
        if (response.success === true) {
          this.showToast('删除评论成功', {
            duration: 1000,
            icon: 'fa-success',
            position: 'top-center',
            fullWidth: false,
          })
          this.listComment()
        }
      }).catch(error => alert(error))
    },
    searchByContent: debounce(function (content) {
      this.content = content
      if (this.content === '') { this.content = null }
      this.listComment()
    }, 400),
    searchByFromUid: debounce(function (fromUid) {
      this.fromUid = fromUid
      if (this.fromUid === '') { this.fromUid = null }
      this.listComment()
    }, 400),
    searchByToUid: debounce(function (toUid) {
      this.toUid = toUid
      if (this.toUid === '') { this.toUid = null }
      this.listComment()
    }, 400),
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
<style lang="scss">
.force-wrap td {
  word-break: break-word; /* 文本行的任意字内断开 */
  word-wrap: break-word; /* IE */
  white-space: -moz-pre-wrap; /* Mozilla */
  white-space: -hp-pre-wrap; /* HP printers */
  white-space: -o-pre-wrap; /* Opera 7 */
  white-space: -pre-wrap; /* Opera 4-6 */
  white-space: pre; /* CSS2 */
  white-space: pre-wrap; /* CSS 2.1 */
  white-space: pre-line; /* CSS 3 (and 2.1 as well, actually) */
}
</style>
